window.addEventListener('scroll', () => {
  const elem = document.getElementById('rocket');
  if (elem) {
    const rocketY = window.scrollY
    const rocketX = -window.scrollY/0.4
    elem.style.backgroundPosition = `${rocketY}px ${rocketX}px`;
  };
});
